'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common');

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-button-delete]', function () {
    var $deleteBtn = (0, _jquery2.default)(this);
    var itemId = $deleteBtn.attr('data-control-button-delete');
    if (!itemId) return;
    var $table = $deleteBtn.closest('.dataTable');
    if ($table.length > 0) {
        var api = $table.DataTable();
        var url = correctUrl(api.init().ajax.url);
        var deleteUrl = url + '(' + itemId + ')';
        (0, _ajax2.default)({ url: deleteUrl, method: 'DELETE' }).done(function (result) {
            _notify2.default.success(Resx.Common.DeleteSuccess);
            api.ajax.reload(null, false);
        });
    }
});

var correctUrl = function correctUrl(url) {
    var correctUrl = url;
    if (url.indexOf('?') > -1) {
        correctUrl = url.substring(0, url.indexOf('?'));
    }
    return correctUrl;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/table-controls.js
// module id = 1092
// module chunks = 1